import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Resources */}
        <div className="footer-section">
          <h3>Resources</h3>
          <ul>
            <li><a href="/platform-usage">Platform Usage</a></li>
            <li><a href="/legal/terms">Terms & Conditions</a></li>
            <li><a href="/legal/privacy">Privacy Policy</a></li>
            <li><a href="/help/faqs">FAQs</a></li>
          </ul>
        </div>

        {/* About NeuraCyb */}
        <div className="footer-section">
          <h3>Company</h3>
          <ul>
           <li><a href="/company/about">About Neuracyb</a></li>
          <li><a href="https://www.neuracyb.com/contact" target="_blank" rel="noopener noreferrer">Contact Us</a></li>
          <li><a href="/platform/overview">Platform</a></li>
          <li><a href="https://www.neuracyb.com/careers" target="_blank" rel="noopener noreferrer">Careers</a></li>
          </ul>
        </div>

        {/* Intelligence Community */}
        <div className="footer-section">
          <h3>Intelligence Community</h3>
          <ul>
            <li><a href="/apply/researcher">Become a Researcher</a></li>
            <li><a href="/become-author">Contribute as Author</a></li>
            <li><a href="/publish-research">Research Publications</a></li>
            <li><a href="/community/forums">Forums</a></li>
          </ul>
        </div>

        {/* Initiatives & Outreach */}
        <div className="footer-section">
          <h3>Initiatives</h3>
          <ul>
            <li><a href="/collaborations">Collaborations</a></li>
            <li><a href="/media/press">Press & Media</a></li>
            <li><a href="/compliance/cookies">Cookies & Compliance</a></li>
            <li><a href="/initiatives">Tech Blogs</a></li>
          </ul>
        </div>

        {/* Social Media */}
        <div className="footer-section">
      <h3>Follow Us</h3>
      <nav className="social-icons" aria-label="Social media">
        <a href="https://www.facebook.com/profile.php?id=61554882964648" aria-label="Facebook" target="_blank"
          rel="noopener noreferrer"><FaFacebookF /></a>
        <a href="https://x.com/NeuraCybSecLabs" aria-label="Twitter / X" target="_blank"
          rel="noopener noreferrer"><FaTwitter /></a>
        <a href="https://www.instagram.com/neuracybsecuritylabs/" aria-label="Instagram" target="_blank"
          rel="noopener noreferrer"><FaInstagram /></a>
        <a href="https://www.youtube.com/@NeuraCybSecLabs" aria-label="YouTube" target="_blank"
          rel="noopener noreferrer"><FaYoutube /></a>
      </nav>
    </div>
      </div>

      {/* Bottom */}
      <div className="divider"></div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} NeuraCyb Security Labs. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
